export default __webpack_public_path__ + "images/icons/user/order-active-purple-5a42a54cbad0b0e77cdd0a79f53e49ec.svg";